module.exports = __webpack_public_path__ + "static/media/p208motor.73637e71.jpg";